//引入
import { JSEncrypt } from "jsencrypt";

/*
 *@描述: 加密参数
 *@参数: 需要加密的参数
 *@作者: 金涛
 *@日期: 2022-06-24 18:42:27
 */
export function setEncryption(param) {
  // 后台给的公钥
  const publicKey =
    "MIICdwIBADANBgkqhkiG9w0BAQEFAASCAmEwggJdAgEAAoGBAKsIIAZULMl3Tm45gDbYsWy99Rqr9nkcpIHLL4G85Zm1koeUnob5R14F/C2UZhS1ixAx3HqaUkQotzJpMTjnoCMUjcGip16Axe5unKB+SvT0TSKJcq6JX7X5B031Kr1gh66O/AQGsCIQuza3WiRqTo3uvCgDV9ukc2UmOcHjfD5/AgMBAAECgYBmyG4+f22e8XUP5rx3uYf+2rWm/rsTk7QFUG9PX4737deOZTFT2hEanywq1Cj4vxVAeUaP45gW4AUgZXkwQnrIPrL/QiR6/OsA+iumQPkaULkXC/saLgJkDePIWr4xcEyqz1naZWQLbTRZTleiKWP7eKPvruUiJKGSi54+MWFNgQJBANTpyfFRjA2KG4mNuhEf6OHYRWdrU+u26cpUyw/A/zrscJPM0Q6G+zp8JeTecRN4OLr/ZEsaKntN/UrPU9DKAb8CQQDNpJ4pZAldkceXGbNC6o81nldlcfIEpauzTbcX/fQAjlvIhQGjyD7OmpgxH2eYZQiIA0y7opjH71aL6O7W13NBAkAJRnIEsD/Aqz6N3H25l0FG7WwAmF1cjGhc5xq9gfPcdkZlOev1jQ3Ou2/PK52Tco5OHygYWXh2TKx3INcO5m3zAkEAtdSE9Nw7W7z22igjVVvJXQOxC0YBVRKYC2cAKfqmsYcuqNLSbFs3Db+sKmM2Wo2bSYiBZLeUl9SMlhFUfirrAQJBAKVocnCjf/Ft3rZMKN1TjhOrNZM/yc2rXI9G6xwi+Ss+uUE4RbtnarltUwCV3MripJmW7liorf5oZJnizDBAXJs=";
  let encryptor = new JSEncrypt(); // 新建JSEncrypt对象
  encryptor.setPublicKey(publicKey); // 设置公钥

  return encryptor.encrypt(JSON.stringify(param)); // 对密码进行加密
}
